import { FEATURE_FLAGS_CONFIG } from 'utils';

// todo: use FEATURE_FLAGS_CONFIG directly instead of re-exporting it
export const FEATURE_FLAGS = {
  LAB_ORDERS_ENABLED: FEATURE_FLAGS_CONFIG.labOrdersEnabled,
  RADIOLOGY_ENABLED: FEATURE_FLAGS_CONFIG.radiologyEnabled,
  IN_HOUSE_LABS_ENABLED: FEATURE_FLAGS_CONFIG.inHouseLabsEnabled,
  NURSING_ORDERS_ENABLED: FEATURE_FLAGS_CONFIG.nursingOrdersEnabled,
  SUPERVISOR_APPROVAL_ENABLED: FEATURE_FLAGS_CONFIG.supervisorApprovalEnabled,
  DEMO_VISITS_ENABLED: FEATURE_FLAGS_CONFIG.demoVisitsEnabled,
  GLOBAL_TEMPLATES_ENABLED: FEATURE_FLAGS_CONFIG.globalTemplatesEnabled,
  FORMS_ENABLED: FEATURE_FLAGS_CONFIG.formsEnabled,
  LEGACY_DATA_ENABLED: FEATURE_FLAGS_CONFIG.legacyDataEnabled,
  LEGACY_PATIENT_FOLLOWUPS_ENABLED: FEATURE_FLAGS_CONFIG.legacyPatientFollowupsEnabled,
  MAILING_PAPER_STATEMENTS_ENABLED: FEATURE_FLAGS_CONFIG.mailingPaperStatementsEnabled,
  SKIP_SENDING_VISIT_NOTE_TO_PATIENT_PORTAL_WHEN_THE_NOTE_IS_SIGNED_FEATURE_FLAG:
    FEATURE_FLAGS_CONFIG.skipSendingVisitNoteToPatientPortalEnabled,
};
